import {mapGetters, mapState} from "vuex";
import Enums from "../model/enums";
import {IconFlag, IconBook, IconArrowRight} from 'src/components/index'

export const FindingsMixin = {
  components: {
    IconFlag, IconBook, IconArrowRight
  },
  data() {
    return {
      showFieldHelp: {},
      showHelpMessageMemo: false,
      showHelpMessageMemoText: '',
      showHelpMessageLearnMoreUrl: null
    }
  },
  created() {
    this.Enums = Enums
  },
  computed: {

    ...mapState({
      seRequest: state => state.se.request,
      seResponse: state => state.se.response,
      seConf: state => state.se.conf,
      seVisitedFindings: state => state.se.visitedFindings
    }),
    ...mapGetters([
      'getNumberOfSelectedTaxFormYears',
      'getBusinessStructureEvaluatedAndDerived',
      'getPreparedRequest',
      'getPY1',
      'getPY2',
      'getHintAmount',
      'isRentalScheduleE',
      'isDisplayInputTaxForms',
      'isWageEarner'
    ]),
  },

  methods: {
    getPropertyRefsCy() {
      return this.seRequest.taxData
        .filter(f => f.year === this.getPY1 && f.formId === Enums.SeTaxFormType.tf8825)
        .flatMap(f => f.fields.find(f => f.id === "rentalPropertyAddress")?.value)
    },
    handleFieldHelp(fieldId) {
      this.showFieldHelp[fieldId] = true
    },
    displayMessageMemo(msgId, learnMoreUrl) {
      let msgText = this.seResponse.messages?.find(msg => msg.id === msgId)?.msg ?? ''
      if (msgText) {
        this.showHelpMessageMemoText = msgText
        this.showHelpMessageMemo = true
        this.showHelpMessageLearnMoreUrl = null
      }
      if (learnMoreUrl) {
        this.showHelpMessageLearnMoreUrl = learnMoreUrl
      }
    },
    findFirstMessageId(memos) {
      if (!memos || memos.length === 0) return null
      return this.seResponse.messages?.find(msg => memos.includes(msg.rule))?.id ?? null
    },
    editField(route) {
      if (!route) return
      // Use the object form of router.push so that Vue Router 4 reliably
      // parses path and query independently, avoiding edge-cases with hash
      // history and string-based query strings.
      const sepIdx = route.indexOf('?')
      if (sepIdx >= 0) {
        const path  = route.substring(0, sepIdx)
        const query = Object.fromEntries(new URLSearchParams(route.substring(sepIdx + 1)))
        this.$router.push({ path, query }).catch(err => {
          // Suppress NavigationDuplicated; rethrow anything unexpected
          if (err?.name !== 'NavigationDuplicated') throw err
        })
      } else {
        this.$router.push(route).catch(err => {
          if (err?.name !== 'NavigationDuplicated') throw err
        })
      }
    },
    getTaxFormFieldLocation(taxYear, retType, taxFormType, fields, fieldId) {
      let taxForm = this.seConf.taxYears.find(ty => ty.year === taxYear).forms
        .find(rtn => rtn.id === retType).forms
        .find(f => f.id === taxFormType)

      let fieldLocation = ''
      if (taxForm.parts) {
        fieldLocation = taxForm.parts.find(p => p.fields.some(ff => ff.id === fieldId))?.route ?? ''
      } else {
        fieldLocation = taxForm.route
      }

      if (fields) {
        // Append ?loc=<fieldId> so the form page can scroll to that field.
        // If the fieldId is not yet in the stored fields array (e.g. field was
        // never saved), omit ?loc= but still return the path so the edit icon
        // remains visible and the form opens at the beginning.
        const locId = fields.find(f => f.id === fieldId)?.id
        return locId ? fieldLocation + '?loc=' + locId : fieldLocation
      }
      return undefined
    },
    getTaxFormValueAsNumber(fields, fieldId) {
      let value = Number(this.getTaxFormValue(fields, fieldId))
      return Number.isNaN(value) ? 0.0 : value
    },
    getTaxFormValue(fields, fieldId, defValue = 0.0) {
      let value = defValue;
      if (fields) {
        value = fields.find(f => f.id === fieldId)?.value;
        if (value === null || value === undefined || value.isEmpty || value === "") {
          value = defValue;
        }
      }
      return value;
    },
    getTaxFormFields(taxYear, taxFormId) {
      let data = this.seRequest.taxData.find(f => f.year === taxYear && f.formId === taxFormId && !f.skipped);
      if (data && data.fields) {
        return data.fields;
      }
      return undefined;
    },
    getMortgagesNotesPayableLessThanOneYearEndOfYear(fields) {
      let mortgagesNotesPayableLessThanOneYearEndOfYear = 0.0
      let rollType = this.getTaxFormValue(fields, 'mortgagePayableLess1YrRolloverType');
      if (rollType === Enums.MortgagePayableLess1YrRolloverType.all) {
        mortgagesNotesPayableLessThanOneYearEndOfYear = this.getTaxFormValue(fields, 'mortgagesNotesPayableLess1YrEndOfTaxYear')
      } else if (rollType === Enums.MortgagePayableLess1YrRolloverType.some) {
        mortgagesNotesPayableLessThanOneYearEndOfYear = this.getTaxFormValue(fields, 'mortgagesNotesPayableLess1YrEndOfTaxYear')
      } else {
        mortgagesNotesPayableLessThanOneYearEndOfYear = this.getTaxFormValue(fields, 'mortgagesNotesPayableLess1YrEndOfTaxYear')
      }
      return mortgagesNotesPayableLessThanOneYearEndOfYear;
    }

  }
}
